import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box, Divider, useMediaQuery } from "@mui/material";

//components
import ATypicalDayMobile from "./ATypicalDayMobile";
import ATypicalDayDesktop from "./ATypicalDayDesktop";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    backgroundImage: "linear-gradient(to top, #05132e 0%, #081b3f 100%)",
    boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
    border: `solid 1px ${theme.palette.blue.main}`,
    borderRadius: "155px 0 155px 0",
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    pb: { xs: "70px" },
    mt: { xs: "103px" },
  },
  title: {
    fontSize: { xs: "32px", md: "54px", xl: "65px" },
    lineHeight: { xs: "41.3px", md: "63px", lg: "79px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    color: theme.palette.white.main,
    mt: { xs: "105px", md: "98px" },
  },
  span: {
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: { xs: "23px", md: "24px", xl: "28px" },
    lineHeight: { xs: "41.3px" },
    fontFamily: theme.typography.montserrat.regular,
    textAlign: { xs: "center" },
    color: theme.palette.white.main,
    mt: { xs: "18px", md: "40px", xl: "55px" },
    maxWidth: { xs: "338px", md: "inherit" },
  },
  program: {
    fontSize: { xs: "23px", md: "24px", xl: "28px" },
    lineHeight: { xs: "50px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    color: theme.palette.white.main,
    mt: { xs: "18px" },
  },
  divider: {
    width: { xs: "289px" },
    border: `0.5px solid ${theme.palette.white.main}`,
    mt: { xs: "45px" },
  },
});

const ATypicalDay = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const componentName = "ATypicalDay";
  const translation = useTranslation(pathname, componentName);

  const { title, subtitle, program } = translation;

  return (
    <Box sx={classes.container}>
      <Typography sx={classes.title}>
        <span style={classes.span}>{title[0]}</span>
        {title[1]}
      </Typography>
      <Typography sx={classes.subtitle}>
        {subtitle[0]}
        <br />
        {subtitle[1]}
      </Typography>
      <Typography sx={classes.program}>{program}</Typography>
      {isMobile && <Divider sx={classes.divider} />}

      {isMobile ? <ATypicalDayMobile /> : <ATypicalDayDesktop />}
    </Box>
  );
};

export default ATypicalDay;
